export interface IImage {
  id?: number;
  name?: string;
  originalName?: string;
  container?: string;
  sipPath?: string;
  mimeType?: string;
  md5?: string;
  size?: string;
  extension?: string;
}

export class ImageDTO implements IImage {
  id?: number;
  name? = null;
  originalName? = null;
  container? = null;
  sipPath? = null;
  mimeType? = null;
  md5? = null;
  size? = null;
  extension? = null;
}

export default class Image extends ImageDTO {
  original = {};
  constructor(dto?: ImageDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
      // dto.customer && (dto.customer = new Customer(dto.customer));
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      id: null,
      name: null,
      originalName: null,
      container: null,
      sipPath: null,
      mimeType: null,
      md5: null,
      size: null,
      extension: null,
    });
  }
}
